"use strict";
import { memo, useMemo } from "react";
import { CombinedLogo } from "components/CurrencyLogo/SplitLogo";
import { getTokenLogoUrl } from "constants/tokenLogos";
export const DoubleCurrencyLogo = memo(function DoubleCurrencyLogo2({
  currencies,
  size = 32,
  customIcon,
  includeNetwork = true
}) {
  const currencyInfos = useMemo(() => {
    const createCurrencyInfo = (currency) => {
      if (!currency) return void 0;
      const logoUrl = currency.isNative ? "/images/tokens/bnb-logo.png" : currency.isToken ? getTokenLogoUrl(currency.address, currency.chainId) : void 0;
      return {
        currency,
        currencyId: currency.isToken ? `${currency.chainId}-${currency.address}` : `${currency.chainId}-NATIVE`,
        logoUrl,
        safetyInfo: void 0,
        isSpam: false
      };
    };
    return [createCurrencyInfo(currencies?.[0]), createCurrencyInfo(currencies?.[1])];
  }, [currencies]);
  const chainId = includeNetwork ? currencyInfos[0]?.currency.chainId ?? null : null;
  return <CombinedLogo
    chainId={chainId}
    inputCurrencyInfo={currencyInfos[0]}
    outputCurrencyInfo={currencyInfos[1]}
    customIcon={customIcon}
    size={size}
  />;
});
